import { Component, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'flowaccount-e-tax-invoice-send-and-scan',
  templateUrl: './e-tax-invoice-send-and-scan.component.html',
  styleUrl: './e-tax-invoice-send-and-scan.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ETaxInvoiceSendAndScanComponent {
  public currentSlide = 1
  public mockContent = [
    {
      image:
        'https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/send-and-scan/owner.png',
      imageWebp:
        'https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/send-and-scan/owner.webp',
      content: [
        {
          title: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.1.INFO.1.TITLE',
          detail: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.1.INFO.1.DETAIL',
          connect: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.1.INFO.1.CONNECT',
          link: 'https://flowaccount.com/faq/knowledge-base/ขั้นตอนการสมัคร-e-tax-invoice-by-email/',
        },
        {
          title: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.1.INFO.2.TITLE',
          detail: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.1.INFO.2.DETAIL',
          connect: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.1.INFO.2.CONNECT',
          link: 'https://flowaccount.com/faq/knowledge-base/e-tax-invoice-by-email/',
        },
        {
          title: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.1.INFO.3.TITLE',
          detail: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.1.INFO.3.DETAIL',
          connect: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.1.INFO.3.CONNECT',
          link: 'https://flowaccount.com/faq/knowledge-base/e-tax-invoice-by-email/',
        },
      ],
    },
    {
      image:
        'https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/send-and-scan/customer.png',
      imageWebp:
        'https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/send-and-scan/customer.webp',
      content: [
        {
          title: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.2.INFO.1.TITLE',
          detail: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.2.INFO.1.DETAIL',
          connect: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.2.INFO.1.CONNECT',
          link: 'https://flowaccount.com/faq/knowledge-base/qr-request-tax-invoice/',
        },
        {
          title: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.2.INFO.2.TITLE',
          detail: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.2.INFO.2.DETAIL',
        },
        {
          title: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.2.INFO.3.TITLE',
          detail: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.2.INFO.3.DETAIL',
        },
      ],
    },
  ]
  goToSlide(slideNo: number) {
    this.currentSlide = slideNo
  }
}
